// This functional component is solely used to allow the react-select elemment contained within to access the light / dark theme toggle of the app at large
import { useMantineColorScheme } from '@mantine/core';
import ClarifyTicketForm from './Clarify-Ticket-Form';

export default function ClarifyTicketFormWrapper(props) {
  const { colorScheme } = useMantineColorScheme();

  return <ClarifyTicketForm {...props} colorScheme={colorScheme} />;
}